
<script setup>
  import { onMounted, ref, computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { LocationSearch, VendorPage, useOrderStore, BasketCheckout } from 'shared-vue'

  const route = useRoute();
  const router = useRouter();
  const orderStore = useOrderStore();


  import { storeToRefs } from 'pinia';
  const { currentVendorItems, itemSubtotal, actualDeliveryFee, totalAmount } = storeToRefs(orderStore);


  function proceedToCheckout() {
    router.push('/checkout');
  }
  function goBackToVendorSelect() {
    router.replace('/vendors');

  }

  const vendorId = ref(null);

  function getStoredLocation() {
    return JSON.parse(localStorage.getItem('customerLocation') || '{}')
  }
  const referral = computed(() => route.query.ref);
  onMounted(async () => {
    const slug = route.params.slug;
    const res = await fetch(`/publicvendor/by-slug/${slug}`);
    if (!res.ok) {
      router.replace('/vendors'); // fallback or 404 page
      return;
    }

    const data = await res.json();
    vendorId.value = data.id;
    let location = getStoredLocation();
    const resdelivery = await fetch(`/publicvendor/delivery-fee?id=${data.id}&delivery=${location.mode !== 'pickup'}&lat=${location.lat}&&lng=${location.lng}`);
    const datadelivery = await resdelivery.json();
    let deliveryFee = datadelivery.deliveryFee;
    let deliveryFreeOrdersOver = datadelivery.deliveryFreeOrdersOver;
    orderStore.setReferral(referral.value);
    orderStore.setVendor({
      vId: data.id,
      deliveryFee: deliveryFee,
      deliveryFreeOrdersOver: deliveryFreeOrdersOver,
      slug: slug
    });

  });
</script>

<template>
  <div class="my-4">
    <LocationSearch />
  </div>
  <button @click="goBackToVendorSelect" class="btn btn-danger my-3">< Back</button>

  <div v-if="vendorId">
    <VendorPage :vendorId="vendorId" />
    <BasketCheckout :onProceedToCheckout="proceedToCheckout" />


  </div>
</template>
